import { useEffect, useCallback, useMemo, useRef, useState } from 'react';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

export const FLOOR_CLIP = {
    B2: {
        y0: -6.5,
        thickness: 0.3,
        stairs: [0.18, 0.37, 0.55, 0.74, 0.92, 1.11, 1.29, 1.48, 1.66, 1.85, 2.03, 2.22],
    },
    B1: {
        y0: -3.9,
        thickness: 0.3,
        stairs: [0.18, 0.35, 0.53, 0.7, 0.88, 1.06, 1.23, 1.41, 1.58, 1.76, 1.94, 2.11, 2.29, 2.46, 2.64, 2.82, 2.99, 3.17, 3.32, 3.54],
    },
    1: {
        y0: 0.0,
        thickness: 0.5,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09, 3.28],
    },
    2: {
        y0: 3.6,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    3: {
        y0: 6.9,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    4: {
        y0: 10.2,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    5: {
        y0: 13.5,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    6: {
        y0: 16.8,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    7: {
        y0: 20.1,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    8: {
        y0: 23.4,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    9: {
        y0: 26.7,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    10: {
        y0: 30.0,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    11: {
        y0: 33.3,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    12: {
        y0: 36.6,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    13: {
        y0: 39.9,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    14: {
        y0: 43.2,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    15: {
        y0: 46.5,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
    16: {
        y0: 49.8,
        thickness: 0.3,
        stairs: [0.16, 0.33, 0.48, 0.64, 0.82, 0.98, 1.14, 1.3, 1.47, 1.63, 1.8, 1.96, 2.1, 2.29, 2.45, 2.61, 2.77, 2.94, 3.09],
    },
};

function glbPathForFloor(f) {
    if (f === 'B2') return '/models/B2.glb';
    if (f === 'B1') return '/models/B1.glb';
    return `/models/F${f}.glb`;
}

export default function FloorViewer({ floor, onPick, overlayTexture, overlaySize = { w: 80, h: 80 }, pickPlaneZ = 1.8, className }) {
    const mountRef = useRef(null);
    const stateRef = useRef({
        glbGroup: null,
        bandGroup: null,
        loadToken: 0,
        lastBox: null,
        isClamping: false,
        meshList: [],
        basePickMesh: null,
    });

    // -------- Domain (0,0) ~ (30,-41) --------
    const DOMAIN = useMemo(() => {
        const minX = 0,
            maxX = 30;
        const minZ = -41,
            maxZ = 0;
        const cx = (minX + maxX) * 0.5; // 15
        const cz = (minZ + maxZ) * 0.5; // -20.5
        return { minX, maxX, minZ, maxZ, cx, cz };
    }, []);

    const AUTO_PALETTE = useMemo(() => {
        const generatePaletteHSL = (startColor, endColor, steps) => {
            const hexToRgb = (hex) => [(hex >> 16) & 0xff, (hex >> 8) & 0xff, hex & 0xff];
            const rgbToHsl = (r, g, b) => {
                r /= 255;
                g /= 255;
                b /= 255;
                const max = Math.max(r, g, b),
                    min = Math.min(r, g, b);
                let h,
                    s,
                    l = (max + min) / 2;
                if (max === min) {
                    h = s = 0;
                } else {
                    const d = max - min;
                    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                    switch (max) {
                        case r:
                            h = (g - b) / d + (g < b ? 6 : 0);
                            break;
                        case g:
                            h = (b - r) / d + 2;
                            break;
                        case b:
                            h = (r - g) / d + 4;
                            break;
                    }
                    h /= 6;
                }
                return [h, s, l];
            };
            const hslToRgb = (h, s, l) => {
                let r, g, b;
                if (s === 0) {
                    r = g = b = l;
                } else {
                    const hue2rgb = (p, q, t) => {
                        if (t < 0) t += 1;
                        if (t > 1) t -= 1;
                        if (t < 1 / 6) return p + (q - p) * 6 * t;
                        if (t < 1 / 2) return q;
                        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                        return p;
                    };
                    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                    const p = 2 * l - q;
                    r = hue2rgb(p, q, h + 1 / 3);
                    g = hue2rgb(p, q, h);
                    b = hue2rgb(p, q, h - 1 / 3);
                }
                return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
            };
            const [r1, g1, b1] = hexToRgb(0xe2e8f0);
            const [r2, g2, b2] = hexToRgb(0x0f172a);
            const [h1, s1, l1] = rgbToHsl(r1, g1, b1);
            const [h2, s2, l2] = rgbToHsl(r2, g2, b2);
            const palette = [];
            for (let i = 0; i < steps; i++) {
                const t = i / (steps - 1);
                const h = h1 + (h2 - h1) * t;
                const s = s1 + (s2 - s1) * t;
                const l = l1 + (l2 - l1) * t;
                const [r, g, b] = hslToRgb(h, s, l);
                palette.push((r << 16) | (g << 8) | b);
            }
            return palette;
        };
        return generatePaletteHSL(0xe2e8f0, 0x0f172a, 21);
    }, []);

    const STAIR_BAND_DELTA = 0.2;
    const STRUCT_BAND_DELTA = 0.2;

    const relToAbsHeights = useCallback((stairsRel, y0) => {
        if (!Array.isArray(stairsRel)) return [];
        return stairsRel
            .map((h) => y0 + h)
            .filter(Number.isFinite)
            .sort((a, b) => a - b);
    }, []);

    const normalizeStructures = useCallback((structs) => {
        if (!Array.isArray(structs)) return [];
        return structs
            .map((s) => {
                if (Number.isFinite(s?.low) && Number.isFinite(s?.high)) {
                    return {
                        low: Math.min(s.low, s.high),
                        high: Math.max(s.low, s.high),
                        color: s.color,
                    };
                }
                if (Number.isFinite(s?.y)) {
                    const delta = Number.isFinite(s.delta) ? s.delta : STRUCT_BAND_DELTA;
                    return { low: s.y, high: s.y + delta, color: s.color };
                }
                return null;
            })
            .filter(Boolean);
    }, []);

    useEffect(() => {
        const mount = mountRef.current;
        if (!mount) return;

        const renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true,
        });
        const DPR = Math.min(window.devicePixelRatio || 1, 2);
        renderer.setPixelRatio(DPR);
        renderer.setSize(mount.clientWidth || 1, mount.clientHeight || 1, false);
        renderer.localClippingEnabled = true;
        mount.appendChild(renderer.domElement);
        renderer.domElement.style.width = '100%';
        renderer.domElement.style.height = '100%';
        renderer.domElement.style.display = 'block';

        const scene = new THREE.Scene();
        const aspect = mount.clientWidth / Math.max(1, mount.clientHeight);
        const camera = new THREE.OrthographicCamera(-20 * aspect, 20 * aspect, 20, -20, 0.1, 5000);
        camera.up.set(0, 1, 0);

        const controls = new OrbitControls(camera, renderer.domElement);
        controls.enableRotate = false;
        controls.enablePan = true;
        controls.enableZoom = true;
        controls.zoomSpeed = 0.7;

        // 📱 모바일에서: 한 손 드래그 = 팬, 두 손 = 줌/팬
        controls.screenSpacePanning = true;
        controls.touches = {
            ONE: THREE.TOUCH.PAN,
            TWO: THREE.TOUCH.DOLLY_PAN,
        };

        scene.add(new THREE.AmbientLight(0xffffff, 0.6));
        const dir = new THREE.DirectionalLight(0xffffff, 0.8);
        dir.position.set(100, 200, 100);
        scene.add(dir);

        const pickPlane = new THREE.Mesh(new THREE.PlaneGeometry(2000, 2000), new THREE.MeshBasicMaterial({ visible: false }));
        pickPlane.rotateX(-Math.PI / 2);
        pickPlane.position.y = pickPlaneZ;
        scene.add(pickPlane);

        // const overlayGeo = new THREE.PlaneGeometry(overlaySize.w, overlaySize.h);
        const overlayGeo = new THREE.PlaneGeometry(1, 1);
        overlayGeo.rotateX(-Math.PI / 2);
        const overlayMat = new THREE.MeshBasicMaterial({
            transparent: true,
            opacity: 1.0,
            depthWrite: false,
        });
        const overlayMesh = new THREE.Mesh(overlayGeo, overlayMat);
        overlayMesh.position.y = pickPlaneZ + 0.01;
        overlayMesh.renderOrder = 999;
        overlayMesh.visible = !!overlayTexture;
        scene.add(overlayMesh);

        const DOMAIN = {
            minX: 0,
            maxX: 30,
            minZ: -41,
            maxZ: 0,
            cx: 15,
            cz: -20.5,
        };
        overlayMesh.position.set(DOMAIN.cx, pickPlaneZ + 0.01, DOMAIN.cz);
        overlayMesh.scale.set(overlaySize.w, 1, overlaySize.h);

        const markerMat = new THREE.MeshBasicMaterial({
            color: 0xff3366,
            transparent: true,
            opacity: 1.0,
            depthTest: false,
            depthWrite: false,
        });
        const marker = new THREE.Mesh(new THREE.SphereGeometry(0.22, 16, 16), markerMat);
        marker.visible = false;
        marker.position.y = pickPlaneZ + 0.15;
        marker.renderOrder = 1000;
        scene.add(marker);

        const gridMaterial = new THREE.LineBasicMaterial({
            color: 0xa0aec0,
            transparent: true,
            opacity: 0.35,
            depthTest: false,
            depthWrite: false,
        });
        const gridGeom = new THREE.BufferGeometry();
        {
            const step = 5;
            const verts = [];
            for (let x = DOMAIN.minX; x <= DOMAIN.maxX; x += step) {
                verts.push(x, pickPlaneZ + 0.01, DOMAIN.minZ, x, pickPlaneZ + 0.01, DOMAIN.maxZ);
            }
            for (let z = DOMAIN.maxZ; z >= DOMAIN.minZ; z -= step) {
                verts.push(DOMAIN.minX, pickPlaneZ + 0.01, z, DOMAIN.maxX, pickPlaneZ + 0.01, z);
            }
            gridGeom.setAttribute('position', new THREE.BufferAttribute(new Float32Array(verts), 3));
        }
        const gridLines = new THREE.LineSegments(gridGeom, gridMaterial);
        gridLines.renderOrder = 995;
        scene.add(gridLines);

        const boxMaterial = new THREE.LineBasicMaterial({
            color: 0x2563eb,
            transparent: true,
            opacity: 0.85,
            depthTest: false,
            depthWrite: false,
        });
        const boxGeom = new THREE.BufferGeometry();
        {
            const y = pickPlaneZ + 0.02;
            const verts = [
                DOMAIN.minX,
                y,
                DOMAIN.maxZ,
                DOMAIN.maxX,
                y,
                DOMAIN.maxZ,
                DOMAIN.maxX,
                y,
                DOMAIN.maxZ,
                DOMAIN.maxX,
                y,
                DOMAIN.minZ,
                DOMAIN.maxX,
                y,
                DOMAIN.minZ,
                DOMAIN.minX,
                y,
                DOMAIN.minZ,
                DOMAIN.minX,
                y,
                DOMAIN.minZ,
                DOMAIN.minX,
                y,
                DOMAIN.maxZ,
            ];
            boxGeom.setAttribute('position', new THREE.BufferAttribute(new Float32Array(verts), 3));
        }
        const boundaryBox = new THREE.LineSegments(boxGeom, boxMaterial);
        boundaryBox.renderOrder = 996;
        scene.add(boundaryBox);

        const safeUpdate = () => {
            stateRef.current.isClamping = true;
            controls.update();
            stateRef.current.isClamping = false;
        };

        const fitOrthoToDomain = (box /* optional */, { preserveZoom = true } = {}) => {
            const w = mount.clientWidth || 1;
            const h = mount.clientHeight || 1;
            const asp = w / Math.max(1, h);

            // 도메인 사이즈
            const sizeX = DOMAIN.maxX - DOMAIN.minX;
            const sizeZ = DOMAIN.maxZ - DOMAIN.minZ;
            const pad = 1.05; // 약간의 여백

            // ✅ 양변 맞춤: 세로 halfH는 (세로크기/2), 가로 맞춤은 (가로크기 / (2*aspect))
            const halfH_vert = sizeZ * pad * 0.5;
            const halfH_horz = (sizeX * pad * 0.5) / Math.max(1e-6, asp);
            const halfH = Math.max(halfH_vert, halfH_horz);

            const prevZoom = camera.zoom || 1;

            camera.top = halfH;
            camera.bottom = -halfH;
            camera.left = -halfH * asp;
            camera.right = halfH * asp;

            const centerY = box ? box.getCenter(new THREE.Vector3()).y : pickPlaneZ;
            const distY = Math.max(halfH * 2, (box ? box.getSize(new THREE.Vector3()).y : 0) + 50);
            camera.position.set(DOMAIN.cx, centerY + distY, DOMAIN.cz);
            camera.lookAt(new THREE.Vector3(DOMAIN.cx, pickPlaneZ, DOMAIN.cz));
            camera.near = 0.1;
            camera.far = box ? camera.position.y - (box.min?.y ?? 0) + 200 : 2000;

            const nextZoom = preserveZoom ? Math.max(1, prevZoom) : 1;
            camera.zoom = nextZoom;
            camera.updateProjectionMatrix();
            controls.minZoom = 1;
            controls.maxZoom = 4;

            controls.target.set(DOMAIN.cx, pickPlaneZ, DOMAIN.cz);
            safeUpdate();
        };

        const getHalfView = () => {
            const halfW = (camera.right - camera.left) / (2 * camera.zoom);
            const halfH = (camera.top - camera.bottom) / (2 * camera.zoom);
            return { halfW, halfH };
        };

        const clampPanToDomain = () => {
            const { halfW, halfH } = getHalfView();
            const domainW = DOMAIN.maxX - DOMAIN.minX,
                domainH = DOMAIN.maxZ - DOMAIN.minZ;
            const t = controls.target,
                pos = camera.position,
                offX = pos.x - t.x,
                offZ = pos.z - t.z;
            let changed = false;
            if (halfW * 2 >= domainW && halfH * 2 >= domainH) {
                if (t.x !== DOMAIN.cx || t.z !== DOMAIN.cz) {
                    t.set(DOMAIN.cx, t.y, DOMAIN.cz);
                    camera.position.set(DOMAIN.cx + offX, pos.y, DOMAIN.cz + offZ);
                    changed = true;
                }
                return changed;
            }
            const minX = DOMAIN.minX + halfW,
                maxX = DOMAIN.maxX - halfW;
            const minZ = DOMAIN.minZ + halfH,
                maxZ = DOMAIN.maxZ - halfH;
            const clampedX = minX > maxX ? DOMAIN.cx : Math.min(Math.max(t.x, minX), maxX);
            const clampedZ = minZ > maxZ ? DOMAIN.cz : Math.min(Math.max(t.z, minZ), maxZ);
            if (clampedX !== t.x || clampedZ !== t.z) {
                t.set(clampedX, t.y, clampedZ);
                camera.position.set(clampedX + offX, pos.y, clampedZ + offZ);
                changed = true;
            }
            return changed;
        };

        const onControlsChange = () => {
            if (stateRef.current.isClamping) return;
            const changed = clampPanToDomain();
            if (changed) safeUpdate();
        };
        controls.addEventListener('change', onControlsChange);

        const disposeObject = (root) => {
            if (!root) return;
            root.traverse((o) => {
                if (o.isMesh) {
                    o.geometry?.dispose?.();
                    if (Array.isArray(o.material)) o.material.forEach((m) => m?.dispose?.());
                    else o.material?.dispose?.();
                }
            });
        };
        const disposeBandGroup = (g) => {
            if (!g) return;
            g.traverse((o) => {
                if (o.isMesh) {
                    o.geometry?.dispose?.();
                    o.material?.dispose?.();
                }
            });
        };

        function applyFloorClipToGroup(group, y0, thickness) {
            const eps = 1e-3;
            const cutY = y0 + thickness + eps;
            const plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), -cutY);
            group.traverse((o) => {
                if (!o.isMesh || !o.material) return;
                const mats = Array.isArray(o.material) ? o.material : [o.material];
                for (const m of mats) {
                    m.clippingPlanes = [plane];
                    m.clipIntersection = true;
                    m.clipShadows = false;
                    m.needsUpdate = true;
                }
            });
        }

        function extractBandMesh(root, yLow, yHigh, { color, opacity = 1.0, nyMin = 0.95, renderOrder = 981, predicate = null } = {}) {
            const out = [];
            const va = new THREE.Vector3(),
                vb = new THREE.Vector3(),
                vc = new THREE.Vector3();
            const e1 = new THREE.Vector3(),
                e2 = new THREE.Vector3(),
                n = new THREE.Vector3();
            const centroid = new THREE.Vector3();

            root.updateWorldMatrix(true, true);
            root.traverse((o) => {
                if (!o.isMesh || !o.geometry || !o.geometry.attributes?.position) return;
                const pos = o.geometry.attributes.position;
                const idx = o.geometry.index;
                const m = o.matrixWorld;

                const pushTri = (ia, ib, ic) => {
                    va.set(pos.getX(ia), pos.getY(ia), pos.getZ(ia)).applyMatrix4(m);
                    vb.set(pos.getX(ib), pos.getY(ib), pos.getZ(ib)).applyMatrix4(m);
                    vc.set(pos.getX(ic), pos.getY(ic), pos.getZ(ic)).applyMatrix4(m);

                    centroid.set((va.x + vb.x + vc.x) / 3, (va.y + vb.y + vc.y) / 3, (va.z + vb.z + vc.z) / 3);
                    if (centroid.y < yLow || centroid.y > yHigh) return;

                    e1.subVectors(vb, va);
                    e2.subVectors(vc, va);
                    n.crossVectors(e1, e2).normalize();
                    if (n.y < nyMin) return;

                    if (predicate && !predicate({ centroid, normal: n, object: o })) return;

                    out.push(va.x, va.y, va.z, vb.x, vb.y, vb.z, vc.x, vc.y, vc.z);
                };

                if (idx) {
                    for (let i = 0; i < idx.count; i += 3) pushTri(idx.getX(i), idx.getX(i + 1), idx.getX(i + 2));
                } else {
                    for (let i = 0; i < pos.count; i += 3) pushTri(i, i + 1, i + 2);
                }
            });

            if (out.length === 0) return null;

            const g = new THREE.BufferGeometry();
            g.setAttribute('position', new THREE.BufferAttribute(new Float32Array(out), 3));
            g.computeBoundingSphere();

            const mat = new THREE.MeshBasicMaterial({
                color,
                opacity,
                transparent: opacity < 1.0,
                side: THREE.DoubleSide,
                depthTest: true,
                depthWrite: false,
                depthFunc: THREE.LessEqualDepth,
                polygonOffset: true,
                polygonOffsetFactor: -0.01,
                polygonOffsetUnits: -0.01,
            });

            const mesh = new THREE.Mesh(g, mat);
            mesh.matrixAutoUpdate = false;
            mesh.renderOrder = renderOrder;
            return mesh;
        }

        function buildBaseFloorBand(root, y0, bandThickness, { color = 0xe2e8f0, opacity = 1.0, nyMin = 0.95, renderOrder = 981 } = {}) {
            return extractBandMesh(root, y0, y0 + bandThickness, {
                color,
                opacity,
                nyMin,
                renderOrder,
            });
        }

        function buildBandsFromRanges(root, ranges, { defaultOpacity = 1.0, nyMin = 0.95, renderOrder = 981 } = {}) {
            const group = new THREE.Group();
            group.renderOrder = renderOrder;

            const colorPick = (i, c) => (c != null ? c : AUTO_PALETTE[i % AUTO_PALETTE.length]);

            ranges.forEach((r, i) => {
                const mesh = extractBandMesh(root, r.low, r.high, {
                    color: colorPick(i, r.color),
                    opacity: defaultOpacity,
                    nyMin,
                    renderOrder,
                });
                if (mesh) group.add(mesh);
            });

            return group;
        }

        const loader = new GLTFLoader();

        const loadFloor = (path, floorKey) => {
            const myToken = ++stateRef.current.loadToken;
            loader.load(
                path,
                (gltf) => {
                    if (myToken !== stateRef.current.loadToken) {
                        disposeObject(gltf.scene);
                        return;
                    }

                    if (stateRef.current.bandGroup) {
                        scene.remove(stateRef.current.bandGroup);
                        disposeBandGroup(stateRef.current.bandGroup);
                        stateRef.current.bandGroup = null;
                    }
                    if (stateRef.current.glbGroup) {
                        scene.remove(stateRef.current.glbGroup);
                        disposeObject(stateRef.current.glbGroup);
                        stateRef.current.glbGroup = null;
                        stateRef.current.meshList = [];
                    }

                    const group = gltf.scene;
                    scene.add(group);
                    stateRef.current.glbGroup = group;

                    const meshes = [];
                    group.traverse((o) => {
                        if (o.isMesh) meshes.push(o);
                    });
                    stateRef.current.meshList = meshes;

                    const cfg = FLOOR_CLIP[floorKey] || {};
                    let { y0, thickness } = cfg;

                    if (!Number.isFinite(y0)) {
                        const boxTmp = new THREE.Box3().setFromObject(group);
                        y0 = boxTmp.min.y;
                    }
                    if (!Number.isFinite(thickness) || thickness <= 0) thickness = 0.3;

                    applyFloorClipToGroup(group, y0, thickness);

                    const bands = new THREE.Group();
                    bands.renderOrder = 981;

                    const baseMesh = buildBaseFloorBand(group, y0, thickness, {
                        color: cfg.baseColor ?? 0xe2e8f0,
                        opacity: 1.0,
                        nyMin: 0.95,
                        renderOrder: 981,
                    });
                    if (baseMesh) bands.add(baseMesh);

                    // 픽킹 메쉬
                    if (stateRef.current.basePickMesh) {
                        try {
                            stateRef.current.scene?.remove(stateRef.current.basePickMesh);
                            stateRef.current.basePickMesh.geometry?.dispose?.();
                            stateRef.current.basePickMesh.material?.dispose?.();
                        } catch {}
                        stateRef.current.basePickMesh = null;
                    }
                    if (baseMesh) {
                        const pickGeo = baseMesh.geometry.clone();
                        const pickMat = new THREE.MeshBasicMaterial({
                            transparent: true,
                            opacity: 0.0,
                            depthTest: false,
                            depthWrite: false,
                            colorWrite: false,
                            side: THREE.DoubleSide,
                        });
                        const basePickMesh = new THREE.Mesh(pickGeo, pickMat);
                        basePickMesh.renderOrder = 1;
                        stateRef.current.scene.add(basePickMesh);
                        stateRef.current.basePickMesh = basePickMesh;
                    }

                    const stairsRel = cfg.stairsRel ?? cfg.stairs ?? [];
                    const stairsAbs = relToAbsHeights(stairsRel, y0);
                    if (stairsAbs.length > 0) {
                        const STAIR_BAND_DELTA = 0.2;
                        const stairRanges = stairsAbs.map((h, i) => ({
                            low: h,
                            high: h + STAIR_BAND_DELTA,
                            color: cfg.stairColors?.[i],
                        }));
                        const stairGroup = buildBandsFromRanges(group, stairRanges, {
                            defaultOpacity: 1.0,
                            nyMin: 0.95,
                            renderOrder: 981,
                        });
                        if (stairGroup.children.length > 0) bands.add(stairGroup);
                    }

                    const structRanges = normalizeStructures(cfg.structures);
                    if (structRanges.length > 0) {
                        const structGroup = buildBandsFromRanges(group, structRanges, {
                            defaultOpacity: 1.0,
                            nyMin: 0.95,
                            renderOrder: 981,
                        });
                        if (structGroup.children.length > 0) bands.add(structGroup);
                    }

                    scene.add(bands);
                    stateRef.current.bandGroup = bands;

                    const box = new THREE.Box3().setFromObject(group);
                    stateRef.current.lastBox = box;
                    fitOrthoToDomain(box);
                    const changed = clampPanToDomain();
                    if (changed) safeUpdate();
                },
                undefined,
                () => {
                    /* onError noop */
                }
            );
        };

        fitOrthoToDomain(null);
        const changedInit = clampPanToDomain();
        if (changedInit) safeUpdate();

        const raycaster = new THREE.Raycaster();
        const mouse = new THREE.Vector2();
        // 📱/🖱 공통: pointerdown/up 으로 "탭"만 픽킹
        const tapStart = { x: 0, y: 0, t: 0, active: false };
        const MOVE_EPS = 6; // px 이상 움직이면 드래그로 간주
        const TIME_EPS = 500; // ms, 너무 오래 누르면 탭 아님

        const onPointerDown = (e) => {
            // 오른쪽 클릭은 무시(마우스 환경)
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            tapStart.x = e.clientX;
            tapStart.y = e.clientY;
            tapStart.t = performance.now();
            tapStart.active = true;
        };

        const onPointerUp = (e) => {
            if (!tapStart.active) return;
            tapStart.active = false;

            // 마우스면 왼쪽 버튼만
            if (e.pointerType === 'mouse' && e.button !== 0) return;

            const dx = e.clientX - tapStart.x;
            const dy = e.clientY - tapStart.y;
            const dt = performance.now() - tapStart.t;

            // 많이 움직였거나 오래 누른 경우 → 드래그/롱프레스임, 픽킹 안 함
            if (Math.hypot(dx, dy) > MOVE_EPS || dt > TIME_EPS) return;

            const rect = renderer.domElement.getBoundingClientRect();
            mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
            mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
            raycaster.setFromCamera(mouse, camera);

            const pickTarget = stateRef.current.basePickMesh;
            if (!pickTarget) {
                marker.visible = false;
                onPick?.(null);
                return;
            }
            const hit = raycaster.intersectObject(pickTarget, false)[0];
            if (!hit) {
                marker.visible = false;
                onPick?.(null);
                return;
            }

            const x = hit.point.x;
            const z = hit.point.z;
            const yAt = hit.point.y;

            marker.position.set(x, yAt + 0.15, z);
            marker.visible = true;
            onPick?.({ x, y: z, h: yAt });
        };

        renderer.domElement.addEventListener('pointerdown', onPointerDown);
        renderer.domElement.addEventListener('pointerup', onPointerUp);

        let resizeRaf = 0;
        const scheduleResize = () => {
            if (resizeRaf) cancelAnimationFrame(resizeRaf);
            resizeRaf = requestAnimationFrame(() => {
                resizeRaf = 0;
                const W = mount.clientWidth || 1;
                const H = mount.clientHeight || 1;
                renderer.setSize(W, H, false);
                fitOrthoToDomain(stateRef.current.lastBox);
                const ch = clampPanToDomain();
            });
        };
        const ro = new ResizeObserver(scheduleResize);
        ro.observe(mount);
        const onFs = () => scheduleResize();
        document.addEventListener('fullscreenchange', onFs);

        let running = true;
        const loop = () => {
            if (!running) return;
            renderer.render(scene, camera);
            requestAnimationFrame(loop);
        };
        loop();

        stateRef.current.renderer = renderer;
        stateRef.current.scene = scene;
        stateRef.current.camera = camera;
        stateRef.current.controls = controls;
        stateRef.current.overlayMat = overlayMat;
        stateRef.current.overlayMesh = overlayMesh;
        stateRef.current.loadFloor = (path) => loadFloor(path, floor);

        return () => {
            running = false;
            controls.removeEventListener('change', onControlsChange);
            renderer.domElement.removeEventListener('pointerdown', onPointerDown);
            renderer.domElement.removeEventListener('pointerup', onPointerUp);
            ro.disconnect();
            document.removeEventListener('fullscreenchange', onFs);
            if (resizeRaf) cancelAnimationFrame(resizeRaf);

            if (stateRef.current.bandGroup) {
                scene.remove(stateRef.current.bandGroup);
                disposeBandGroup(stateRef.current.bandGroup);
                stateRef.current.bandGroup = null;
            }
            if (stateRef.current.glbGroup) {
                scene.remove(stateRef.current.glbGroup);
                disposeObject(stateRef.current.glbGroup);
                stateRef.current.glbGroup = null;
                stateRef.current.meshList = [];
            }
            if (stateRef.current.basePickMesh) {
                try {
                    stateRef.current.scene?.remove(stateRef.current.basePickMesh);
                    stateRef.current.basePickMesh.geometry?.dispose?.();
                    stateRef.current.basePickMesh.material?.dispose?.();
                } catch {}
                stateRef.current.basePickMesh = null;
            }

            overlayGeo.dispose();
            overlayMat.dispose();
            pickPlane.geometry.dispose();
            pickPlane.material.dispose();
            gridGeom.dispose();
            gridMaterial.dispose();
            boxGeom.dispose();
            boxMaterial.dispose();
            marker.geometry.dispose();
            marker.material.dispose();

            mount.removeChild(renderer.domElement);
            renderer.dispose();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [floor, pickPlaneZ, overlaySize.w, overlaySize.h, AUTO_PALETTE]);

    useEffect(() => {
        const s = stateRef.current;
        if (!s || !s.loadFloor) return;
        const path = glbPathForFloor(floor);
        s.loadFloor(path);
    }, [floor]);

    useEffect(() => {
        const s = stateRef.current;
        if (!s || !s.overlayMat || !s.overlayMesh) return;
        s.overlayMat.map = overlayTexture || null;
        s.overlayMat.needsUpdate = true;
        s.overlayMesh.visible = !!overlayTexture;
    }, [overlayTexture]);

    useEffect(() => {
        const s = stateRef.current;
        if (!s || !s.overlayMesh) return;
        s.overlayMesh.scale.set(overlaySize.w, 1, overlaySize.h);
    }, [overlaySize.w, overlaySize.h]);

    return <div ref={mountRef} style={{ height: '100%', width: '100%' }} />;
}
